export var TIME_SERIES_INTERVAL = /* @__PURE__ */ ((TIME_SERIES_INTERVAL2) => {
  TIME_SERIES_INTERVAL2["HOUR"] = "hour";
  TIME_SERIES_INTERVAL2["DAY"] = "day";
  TIME_SERIES_INTERVAL2["WEEK"] = "week";
  TIME_SERIES_INTERVAL2["MONTH"] = "month";
  return TIME_SERIES_INTERVAL2;
})(TIME_SERIES_INTERVAL || {});
